<template>
  <div class="entrance">
    <template v-if="region.login">
      <dy-image class="login-pic" :src="require('../../assets/images/login-pic.png')"></dy-image>
      <login class="bac" @showRegion="showRegion"></login>
    </template>
    <forget-password class="bac" v-if="region.forgetPassword" @showRegion="showRegion"></forget-password>
  </div>
</template>

<script>
  import Login from '@/views/common/Login.vue';
  import ForgetPassword from '@/views/common/ForgetPassword.vue';

  export default {
    name: 'Entrance',
    data() {
      return {
        region: {
          login: true,
          forgetPassword: false
        }
      }
    },
    components: {
      Login,
      ForgetPassword
    },
    methods: {
      showRegion(name) {
        Object.keys(this.region).forEach(val => {
          this.region[val] = false;
        });
        this.region[name] = true;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .entrance {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .login-pic {
      width: 400px;
      margin-right: 80px;
    }
    .bac {
      box-shadow: 0 0 24px 0 rgba(0, 167, 255, .1);
      padding: 48px;
      width: 500px;
    }
  }
</style>